import { Editor, Path, Transforms } from 'slate';
import { isExpanded, getNodes } from '@udecode/slate-plugins';
import { BLOCK_TABLE, BLOCK_TABLE_CELL } from '../types';
import { getEmptyTableCell } from '../utils/get-empty-table-cell';

export const changeCellBackgroundColor = (editor, color) => {
  const isRange = isExpanded(editor.selection);
  const currentCells = isRange ? Array.from(Editor.nodes(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })) : [Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })];
  if (currentCells) {
    currentCells.map((cell) => {
      const [, cellPath] = cell;
      Transforms.setNodes(
        editor,
        {
          cellBackgroundColor: color,
        },
        {
          at: cellPath,
        },
      );
    })
      
  }
};